import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/user/Login'
import Register from '@/components/user/Register'
import UsersList from '@/components/user/UsersList'
import Profile from '@/components/user/Profile'
import Dashboard from '@/components/Dashboard'
import Targets from '@/components/Targets'
import TargetsList from '@/components/TargetsList'
import Indicators from '@/components/Indicators'
import IndicatorsList from '@/components/IndicatorsList'
import StandardValues from '@/components/StandardValues'
import Logout from '@/components/Logout'
import RollingValues from './components/RollingValues'
import AverageValues from './components/AverageValues'
import ResetPassword from './components/user/ResetPassword'
import Activate from './components/user/Activate'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/wachtwoord-opvragen/:token',
      name: 'resetpassword',
      component: ResetPassword,
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
    },

    {
      path: '/register/:subscription(standard|student|extensive|watch)',
      name: 'register',
      component: Register,
    },
    {
      path: '/register/:rest?',
      name: 'register-redirect',
      redirect: { name: 'login' },
    },
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
    },
    {
      path: '/streefwaarden/:targetId',
      name: 'targets',
      component: Targets,
    },
    {
      path: '/huidige-situatie/:indicatorId',
      name: 'indicators',
      component: Indicators,
    },
    {
      path: '/standaardwaarden',
      name: 'standardvalues',
      component: StandardValues,
    },
    {
      path: '/rolling',
      name: 'rollingvalues',
      component: RollingValues,
    },
    {
      path: '/average',
      name: 'averagevalues',
      component: AverageValues,
    },
    {
      path: '/gebruikers',
      name: 'users',
      component: UsersList,
    },
    {
      path: '/streefwaarden',
      name: 'targetslist',
      component: TargetsList,
    },
    {
      path: '/huidige-situatie',
      name: 'indicatorslist',
      component: IndicatorsList,
    },
    {
      path: '/profiel',
      name: 'profile',
      component: Profile,
    },
    {
      path: '/activate',
      name: 'activate',
      component: Activate,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})
